import {
  CorridorType,
  FilterInput,
  KineticModule,
  PrivilegeType,
  useCorridorMapListQuery,
} from '@kinetic-ui/data-layer';
import { EntityTypes } from 'const';
import { UserContext } from 'contexts';
import { getNodes } from 'kineticUtils/data';
import { hasEntityPrivilege } from 'kineticUtils/privileges';
import { useContext, useMemo } from 'react';

export const useCorridorMapListData = ({
  activeFilters = [],
  searchText,
  skip,
}: {
  activeFilters?: FilterInput[];
  searchText?: string;
  skip: boolean;
}) => {
  const { privileges: userPrivileges } = useContext(UserContext);
  const { data } = useCorridorMapListQuery({
    fetchPolicy: 'cache-and-network',
    variables: { filters: activeFilters, searchText: searchText },
    skip,
  });

  const rowData = useMemo(() => {
    return Object.values(getNodes(data?.corridors))?.filter((corridor) =>
      hasEntityPrivilege(
        userPrivileges,
        PrivilegeType.View,
        corridor.type === CorridorType.Corridor ? KineticModule.Corridors : KineticModule.Tunnels,
        EntityTypes.CORRIDOR,
        corridor.id
      )
    );
  }, [data, userPrivileges]);

  return { rowData };
};
